module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "create-audience__loading"
  }, [_c('loading-dots')], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "create-target-form__name-section"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('target-name', {
    attrs: {
      "isNewTarget": _vm.isNewTarget,
      "targetType": _vm.target.target,
      "initialValue": _vm.initialTarget.display_name,
      "initialTargetAction": _vm.initialTargetAction,
      "disabled": !!_vm.targetName,
      "validateAllNames": _vm.targetCreated
    },
    on: {
      "updateName": function (val) { return (_vm.target.display_name = val); },
      "updateNameIsValid": function (isValid) { return (_vm.nameIsValid = isValid); }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('advertiser-select', {
    attrs: {
      "initialValue": _vm.target.advertiser,
      "showAdvertiserId": true
    },
    on: {
      "update": function (val) { return (_vm.target.advertiser = val); }
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('streaming-select', {
    attrs: {
      "initialValue": _vm.target.viewing_stream,
      "viewingOption": _vm.viewingOption
    },
    on: {
      "input": function (val) { return (_vm.target.viewing_stream = val); }
    }
  })], 1)], 1), _vm._v(" "), (_vm.isDuplicating) ? _c('div', {
    staticClass: "create-audience__button-area justify-space-around"
  }, [_c('action-button', {
    attrs: {
      "disabled": !_vm.canBuildAudience || _vm.buttonClicked,
      "label": "Duplicate Audience",
      "color": "secondary",
      "id": "duplicateAudienceBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onDuplicate.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isDuplicating) ? _c('div', {
    staticClass: "create-audience__button-area justify-space-around"
  }, [_c('action-button', {
    attrs: {
      "disabled": _vm.buttonClicked,
      "label": "attach a file",
      "id": "attachAFileBtn",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onFile.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": !_vm.canActivate || _vm.buttonClicked,
      "label": "activate",
      "id": "activateAudienceBtn",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onActivate.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": !_vm.canBuildAudience || _vm.buttonClicked,
      "label": "build audience",
      "id": "buildAudienceBtn",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onBuild.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-087d061a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/forms/CreateAudience.vue
// module id = 1984
// module chunks = 0